import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kpi-benchmarking',
  templateUrl: './kpi-benchmarking.component.html',
  styleUrls: ['./kpi-benchmarking.component.scss']
})
export class KpiBenchmarkingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
